import { useEffect } from 'react';
import type { User } from '../types';

// Extend Window interface for Crisp
declare global {
  interface Window {
    $crisp: unknown[];
  }
}

/**
 * Identify the current user with Crisp chat
 */
export function useCrisp(user: User | undefined) {
  useEffect(() => {
    if (!user || !window.$crisp) return;

    // Set user email
    window.$crisp.push(['set', 'user:email', [user.email]]);

    // Set user nickname if available
    if (user.name) {
      window.$crisp.push(['set', 'user:nickname', [user.name]]);
    }

    // Set session data with additional user info
    window.$crisp.push([
      'set',
      'session:data',
      [
        [
          ['user-id', user.id],
          ['organization-id', user.organization_id],
          ['role', user.role],
        ],
      ],
    ]);
  }, [user]);
}
